import {Store} from "../../model/Store";
import {LogaProxy} from "../../model/LogaProxy";
import {SlotsForStoreReportSlot} from "../../model/ReportingSlots";
import {Order} from "../../model/Order";

export class OrderInfo {

  public operation: LogaProxy;

  public store: Store;

  public order: number;

  /**
   * date to setup by default, if needed from the create process, as loga day
   */
  public defaultDate: number;

  /**
   * in case of duplication, use this to load an existing, to prefill info
   */
  public duplicateFromOrder: number;

  /**
   * if planned form a slot selection
   */
  public planningSlot: SlotsForStoreReportSlot;

  /**
   * tour identifier, if the user is planning several mission, as a tour for the same resource
   */
  public dailyTourPlanning: number;


  /**
   * logaDay for this tour
   */
  tourPlanningDay: number;

  /**
   * previous order in selected tour, helps to compute next opening hours
   */
  previousOrderInTour: Order;
  tourPlanningIdentifier: null;

  constructor() {
    this.operation = new LogaProxy();
    this.store = new Store();
  }
}



// WEBPACK FOOTER //
// ./src/pages/nav/OrderInfo.ts